export function getAuthSaltForQuestion(authAnswerSalts, questionId) {
  for (const element of authAnswerSalts) {
    if (element.questionId == questionId) {
      return element.authAnswerSalt;
    }
  }
  return null;
}

/**
 * Returns keyAnswerSalt corresponding to the particular questionId.
 *
 * @param questionId     question id corresponding to which key salt is to be found.
 * @param keyAnswerSalts arraylist from which key salt is to be found.
 * @return keyAnswerSalt corresponding to the questionId.
 */
export function findKeyAnswerSalt(questionId, keyAnswerSalts) {
  for (const element of keyAnswerSalts) {
    if (element.questionId == questionId) {
      return element.keyAnswerSalt;
    }
  }
  return null;
}

/**
 * Returns the encrypted user private key part corresponding to the questionId.
 *
 * @param questionId        questionId corresponding to which encrypted user private key part
 *                          is to be found.
 * @param securityQuestions arrayList from which questions data can be found.
 * @return encrypted user private key part corresponding to the questionId.
 */
export function findEncryptedUserPrivateKeyPart(questionId, securityQuestions) {
  for (const element of securityQuestions) {
    if (element.questionId == questionId) {
      return element.encryptedUserPrivateKeyPart;
    }
  }
  return null;
}

/**
 * Returns the answer corresponding to the particular questionId.
 *
 * @param questionId id of the question whose answer is to be found.
 * @param answers    arraylist from which answers are to be found.
 * @return answer corresponding to questionId.
 */
export function findAnswer(questionId, answers) {
  for (const element of answers) {
    if (element.questionId == questionId) {
      return element.answer;
    }
  }
  return null;
}
